import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import InputField from 'components/elements/InputField';
import onClickOutside from 'react-onclickoutside';

import './LinkName.css';


const ENTER_KEY = 13;

class LinkName extends Component {
  static propTypes = {
    patchLink: PropTypes.func.isRequired,
    linkName: PropTypes.string.isRequired,
    linkId: PropTypes.number.isRequired,
    isHeader: PropTypes.number.isRequired,
  };

  state = {
    selectedLinkId: null,
    initialValue: '',
    currentValue: '',
    linkErrorId: null,
    isHeader: false,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.linkName) {
      this.setState({
        initialValue: this.props.linkName,
        currentValue: this.props.linkName,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  _changeTitle = () => {
    if (!this._validation_error()) {
      this.setState({
        linkErrorId: this.props.linkId,
        selectedLinkId: null,
        initialValue: this.state.currentValue,
      });
      this.props.patchLink(
        this.props.linkId,
        { name: this.state.currentValue },
      );
    }
  };

  handleClickOutside = () => {
    const { initialValue, currentValue } = this.state;
    if (currentValue !== initialValue) {
      this._changeTitle();
    }
  };

  onEnterClick = event => {
    if (event.keyCode === ENTER_KEY) {
      if (this.props.linkId === this.state.selectedLinkId) {
        this._changeTitle();
      }
    }
  };

  _validation_error = () => {
    let error = null;
    if (this.state.currentValue === '') {
      error = {
        id: `link_name_id_${this.props.linkId}`,
        text: i18n.t("Name cannot be empty")
      };
    } else if (this.props.isHeader && this.state.currentValue.length > 35) {
      error = {
        id: `link_name_id_${this.props.linkId}`,
        text: i18n.t("Header name can not have more than 35 symbols")
      };
    } else if (this.state.currentValue.length > 1000) {
      error = {
        id: `link_name_id_${this.props.linkId}`,
        text: i18n.t("Link name can not have more than 1000 symbols")
      };
    }
    return error;
  }

  render() {
    const nameError = this._validation_error();

    return (
      <div className="link-name__component">
        <InputField
          hoverable
          value={this.state.currentValue}
          onChange={(e) => {
            e.preventDefault();
            this.setState({
              selectedLinkId: this.props.linkId,
              currentValue: e.target.value,
            });
          }}
          error={nameError}
        />
      </div>
    );
  }
}

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    patchLink,
  },
)(onClickOutside(LinkName));
